import _ from 'lodash';
import { getRequest } from '../../Common/network-call';
import { INSTANCE_URL } from '../../Common/constant';

export const MY_BOOKED_NEWS = 'MY_BOOKED_NEWS';
export const FETCH_NEWS = 'FETCH_NEWS';
export const FETCH_NEWS_DETAILS = 'FETCH_NEWS_DETAILS';

export const fetchBookedNews = (session, callback) => {
  let filter = encodeURI(
    `(eventid=${session.eventid})AND(appuserid=${session.userid})AND(type=news)`
  );
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/bookmarks?include_count=true&fields=bookmarkid,typeid&filter=(${filter})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      response => {
        // console.log('response :- ', response);
        dispatch({
          type: MY_BOOKED_NEWS,
          payload: { resource: response.resource, count: response.meta.count }
        });
        callback({
          success: 1,
          resource: response.resource,
          count: response.meta.count
        });
      },
      error => {
        // callback({ success: 0, message: error });
      }
    );
  };
};

export const clearBookedNews = () => {
  return dispatch => {
    dispatch({
      type: MY_BOOKED_NEWS,
      payload: {}
    });
  };
};

export const fetchNews = (session, callback) => {
  let filter = encodeURI(`(eventid=${session.eventid})`);
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/news?filter=(${filter})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      response => {
        // console.log('fetchUsers response: ', response);
        dispatch({
          type: FETCH_NEWS,
          payload: { data: response.resource, count: response.resource.length }
        });
        callback({ success: 1 });
      },
      error => {}
    );
  };
};

export const setNewsDetails = payloadObj => {
  return dispatch =>
    dispatch({ type: FETCH_NEWS_DETAILS, payload: { data: payloadObj } });
};

export const fetchNewsDetails = (session, newsid, callback) => {
  let filter = encodeURI(`(newsid=${newsid})AND(eventid=${session.eventid})`);
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/news?filter=${filter}`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      response => {
        dispatch({
          type: FETCH_NEWS_DETAILS,
          payload: { data: response.resource, count: response.resource.length }
        });
        callback({ success: 1 });
      },
      error => {}
    );
  };
};

export const clearNewsDetails = () => {
  return dispatch => {
    dispatch({ type: FETCH_NEWS_DETAILS, payload: [] });
  };
};
